import React, { useRef } from "react";
import CustomDatePicker from "./DateInput";
import ButtonWithText from "./Button";
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const StyledCustomDatePicker = styled(CustomDatePicker)`
    input {
        caret-color: transparent;
    }
`;

const EditableDateField = ({ value, onChange, highlightedDates }) => {
    const datePickerRef = useRef();

    const handleIconClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };

    return (
        <StyledCustomDatePicker
            highlightedDates={highlightedDates}
            leftIcon={"calendar"}
            value={value}
            onChange={(date) => {
                onChange(date);
            }}
            variant="unstyled"
            componentVariant={"l3rnTech"}
            ref={datePickerRef}
            leftIconClick={handleIconClick}
            showMonthYearDropdown={true}
        />
    );
};

/**
 * A date field with an add button beside it.
 *
 * Takes the date and both callbacks as props. It previously read `selectedDate` from
 * `ExtensionContext` and wrote back through its `setState`, which tied a kit component to
 * one feature module — nothing outside extension could use it, and the kit could not be
 * tested or reasoned about without that module present.
 *
 * @param {Date}     value            the selected date
 * @param {Function} onChange         called with the newly picked Date
 * @param {Function} onAddClick       called when the add button is pressed
 * @param {Array}    highlightedDates dates to mark in the picker
 */
const DateHeader = ({ value, onChange, onAddClick, highlightedDates }) => {
    return (
        <Wrapper>
            <div style={{ flex: 1 }}>
                <EditableDateField value={value} onChange={onChange} highlightedDates={highlightedDates} />
            </div>
            <ButtonWithText
                onClick={onAddClick}
                buttonStyle="default"
                icon="add"
                iconType="material"
                variant="l3rnTech"
                type="default"
                size="circle"
            />
        </Wrapper>
    );
};

export default DateHeader;
